import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { SystemOverview } from './components/SystemOverview';
import { Modules } from './components/Modules';
import { LookInside } from './components/LookInside';
import { Bonuses } from './components/Bonuses';
import { Differentiators } from './components/Differentiators';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SalesPopup } from './components/SalesPopup';
import { META_PIXEL_ID } from './data/content';
type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push: Fbq;
  loaded: boolean;
  version: string;
};
declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}
function initMetaPixel() {
  if (typeof window === 'undefined' || window.fbq) return;
  const n = function (...args: unknown[]) {
    if (n.callMethod) n.callMethod(...args);else n.queue.push(args);
  } as Fbq;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  window.fbq = n;
  if (!window._fbq) window._fbq = n;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const first = document.getElementsByTagName('script')[0];
  if (first && first.parentNode) first.parentNode.insertBefore(script, first);else (document.head || document.documentElement).appendChild(script);
  n('init', META_PIXEL_ID);
  n('track', 'PageView');
}
interface AppProps {
  showSalesPopup?: boolean;
}
export function App({
  showSalesPopup = true
}: AppProps) {
  useEffect(() => {
    try {
      initMetaPixel();
    } catch (err) {
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="35ymodf6r9ya">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="35ghusegjner" />
      </noscript>
      <div className="flex min-h-screen w-full flex-col items-center overflow-x-hidden bg-blush/40" data-id="element-2" data-mp="d3wcv6glvgtj">
        <main className="w-full max-w-3xl bg-white shadow-2xl" data-id="element-3" data-mp="86cld4uwd7jn">
          <Hero data-id="element-4" data-mp="3gmfwxlp4rgd9" />
          <PainPoints data-id="element-5" data-mp="3glwcnyc0cfw2" />
          <SystemOverview data-id="element-6" data-mp="3gja8m8obsiil" />
          <Modules data-id="element-7" data-mp="3bmjsjlcitmx6" />
          <LookInside data-id="element-8" data-mp="3bn2zy84joswy" />
          <Bonuses data-id="element-9" data-mp="3bnutzeihuil4" />
          <Differentiators data-id="element-10" data-mp="3bk718hkvi07g" />
          <Offer data-id="element-11" data-mp="3qaxt1pmgszak" />
          <Guarantee data-id="element-12" data-mp="3qbfv52vt67qe" />
          <Testimonials data-id="element-13" data-mp="3qbzcoihjqu3w" />
          <FAQ data-id="element-14" data-mp="3qdakcte44m0a" />
          <FinalCTA data-id="element-15" data-mp="3lkhe212zx5m3" />
          <Footer data-id="element-16" data-mp="3ljxukfxp695y" />
        </main>
        {showSalesPopup ? <SalesPopup data-id="element-17" data-mp="3lj67jti61jra" /> : null}
      </div>
    </>;
}